module.exports = __webpack_public_path__ + "img/xwqycx.192d79a2.png";